import {Component, Input} from '@angular/core';
import {dayNamesTranslation} from '../../constants/day-names-translation.constant';
import {TranslationSelectorService} from '../../translation-selector.service';

@Component({
  selector: 'app-week-days',
  templateUrl: './week-days.component.html',
  styleUrls: ['./week-days.component.scss']
})
export class WeekDaysComponent {
  public readonly dayNames = dayNamesTranslation;
  @Input() weekDays: number[];

  constructor(
    public translationSelectorService: TranslationSelectorService
  ) {
  }
}
